import external_auth from 'api/auth_external';
import { jwtDecode } from 'jwt-decode';

const authType = window.REACT_APP_AUTH_TYPE !== 'REPLACE_REACT_APP_AUTH_TYPE' ? window.REACT_APP_AUTH_TYPE : process.env.REACT_APP_AUTH_TYPE; 
const loginAdress = authType === 'blitz' ? 'blitz-auth' : 'login';

const getCookie = (name: string) => {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : '';
}

const setCookie = (name: string, val: string, expires: any) => {
  const date = new Date();
  date.setDate(date.getDate() + ( expires * 86400000));
  document.cookie = name+"="+val+"; path=/; expires=" + date.toUTCString();
}

const deleteCookie = (name: string) => {
  setCookie(name, "", {
      'max-age': -1
  })
}

const saveTokensAfterAuthentication = (tokens: {access_token: string, refresh_token: string}) => {  
  setCookie('athena-token', tokens.access_token, 1);
  setCookie('refresh_token', tokens.refresh_token, 1);
  const decode_refresh_token = jwtDecode(tokens.refresh_token);
  const expired_refresh_token = decode_refresh_token?.exp && decode_refresh_token.exp * 1000;
  localStorage.setItem('expired_refresh_token', String(expired_refresh_token));
}

const resetTokensAndSendToLogin = async () => {
  if (authType === 'blitz') {
    try {
      const token = getCookie('athena-token');
      const logoutUrl = await external_auth.logoutHandle(token);
      deleteCookie('athena-token');
      deleteCookie('refresh_token');
      localStorage.removeItem('expired_refresh_token');
      window.location.href = logoutUrl.data.url;
    } catch (e) {
      console.log(e, 'logoutHandle error');
      deleteCookie('athena-token');
      deleteCookie('refresh_token');
      localStorage.removeItem('expired_refresh_token');
      window.location.href = `/${loginAdress}`;
    }
  } else {
    deleteCookie('athena-token');
    deleteCookie('refresh_token');
    localStorage.removeItem('expired_refresh_token');
    window.location.href = `/${loginAdress}`;
  }
}
export { getCookie, setCookie, deleteCookie, saveTokensAfterAuthentication, resetTokensAndSendToLogin }

